import React from 'react';
import { useLocation } from 'react-router-dom';

import ObjectsTable from './ObjectsTable';
import constants from '../../constants';

const ObjectsPage = () => {
  const location = useLocation();
  const pathParts = location['pathname'].split('/');
  const objectType = pathParts[pathParts.length - 1];
  const objectSchema = constants.getObjectSchema(objectType);
  
  if (!objectSchema && Object.keys(constants.objectsSchema).length > 0) {
    return <div className="error-page">Invalid object type: {objectType}</div>;
  }
  
  // If schema not loaded yet, return null (or loading state)
  if (!objectSchema) return null;
  
  return <ObjectsTable objectType={objectType} objectSchema={objectSchema} />;
};

export default ObjectsPage;